// components/Footer.js
import React from "react";
import { Link } from "react-router-dom";
import "./css/Footer.css";

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-inline">
        <p>© {new Date().getFullYear()} GTAFanPage</p>
        <div className="footer-links">
          <Link to="/contact">Contact</Link>
          <Link to="/about-us">About</Link>
          <Link to="/terms-and-conditions">Terms</Link>
          <Link to="/privacy-policy">Privacy</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
